<template>
  <div>
    <label class="kyc-sub-title">{{ label }}</label>
    <div
        class="imi-container"
        :style="imgId ? 'border-color: rgb(var(--rgb-system-primary));' : 'border-color: rgba(var(--rgb-text-grey-color), .7);'"
    >
      <div>
        <div v-if="imgId">
                  <img v-if="imgSrc" height="100" style="display: block; margin-left: auto; margin-right: auto" :src="imgSrc">
        </div>
        <div v-else>
          <div class="imi-message-container">
            <p class="pl-1">Зураг байхгүй</p>
          </div>
        </div>
        <div v-if="canReupload">
          <label class="d-flex justify-content-center mt-xl-3">
            <span class="ic-button-wrapper card-button" @click="editIds">Дахин зураг оруулах</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {downloadUserId} from "../../../api/user";

export default {
  props: {
    label: {type: [String]},
    imgId: {type: [Number, String]},
    // Нэг удаа оруулсан зургийг дахин оруулахгүй. Зөвхөн татгалзсан үед true.
    canReupload: {type: Boolean, default: false},
  },
  data() {
    return {
      imgSrc: null,
    }
  },
  watch: {
    // Зураг Bearer токентой татагдах тул <img src>-д шууд URL өгөх боломжгүй, blob болгон харуулна
    imgId: {
      immediate: true,
      async handler(id) {
        this.revokeImgSrc()
        if (!id) return
        try {
          const {data} = await downloadUserId(id)
          if (id !== this.imgId) return
          this.imgSrc = URL.createObjectURL(data)
        } catch (e) {
          console.error(e)
        }
      }
    }
  },
  beforeDestroy() {
    this.revokeImgSrc()
  },
  methods: {
    revokeImgSrc() {
      if (this.imgSrc) URL.revokeObjectURL(this.imgSrc)
      this.imgSrc = null
    },
    editIds() {
      this.$emit('emptyIds')
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./ImageInput.scss";
</style>
